import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import { routerMiddleware, connectRouter } from 'connected-react-router'

import thunk from 'redux-thunk'
import { reducer as formReducer } from 'redux-form'
import * as SideMenu from './SideMenu'
import * as UserManagement from './UserManagement'
import * as SearchStore from './SearchStore'
import * as Layout from './Layout'
import { authReducer } from '../store/auth'
import { smeReducer } from '../store/sme'

import { accreditationReviewReducer } from './TechnicalAccreditation'
import { addLiabilitiesReducer } from './LoanApplicationAddLiabilities'
import { addressTypeReducer } from './AddressType'
import { adminStatisticsReducer } from './AdminStatistics'
import { adminUnlockQuestionnaireReducer } from './AdminUnlockQuestionnaire'
import { bankReducer } from './bank'
import { beeStatusReducer } from './BeeStatus'
import {registrationStatusReducer} from "./RegistrationStatus";
import { cityReducer } from './City'
import { clientReferenceReducer } from './ClientReference'
import { companyAddressReducer } from './CompanyAddress'
import { companyContactReducer } from './CompanyContact'
import { companyDirectorReducer } from './CompanyDirector'
import { companyDocumentExpiredReducer } from './CompanyDocumentExpired'
import { companyDocumentReducer } from './CompanyDocument'
import { companyOwnerReducer } from './CompanyOwner'
import { companyOwnershipReducer } from './CompanyOwnership'
import { companyRankingReducer } from './CompanyRanking'
import { companyReducer } from './Company'
import { companyTypeReducer } from './CompanyType'
import { complianceReferenceReducer } from './ComplianceReference'
import { createBrowserHistory } from 'history'
import { documentRejectionReasonReducer } from './DocumentRejectionReason'
import { documentStatusReducer } from './DocumentStatus'
import { documentTypeReducer } from './DocumentType'
import { economicSectorReducer } from './EconomicSector'
import { educationLevelReducer } from './EducationLevel'
import { enterpriseSizeReducer } from './EnterpriseSize'
import { esdStatisticsReducer } from './EsdStatistics'
import { faqReducer } from './Faq'
import { fundingRecommendationReducer } from './FundingRecommendation'
import { genderReducer } from './Gender'
import { growthPlanPeriodReducer } from './GrowthPlanPeriods'
import { industryGroupReducer } from './IndustryGroup'
import { industryReducer } from './Industry'
import { industryReducer_ } from './Industry__'
import { industrySectorReducer } from './IndustrySector'
import { industrySectorReducer_ } from './IndustrySector__'
import { industrySubSectorReducer } from './IndustrySubSector__'
import { inviteReducer } from './Invite'
import { itemToBeFundedReducer } from './LoanApplicationItemToBeFunded'
import { loanApplicationReducer } from './LoanApplication'
import { localMunicipalityReducer } from './LocalMunicipality'
import { LoginReusePreventionReducer } from "./LoginReusePrevention";
import { municipalityReducer } from './Municipality'
import { promisedDocumentsReducer } from './PromisedDocuments'
import { nationalityReducer } from './Nationality'
import { notificationMessageReducer } from './NotificationMessage'
import { opportunitiesInterestsReducer } from './OpportunitiesInterests'
import { opportunityCollaboratorsReducer } from './OpportunityCollaborators'
import { opportunityReducer } from './Opportunities'
import { PermissionReducer } from './Permission'
import { platformFeaturesReducer } from './PlatformFeatures'
import { platformSettingsReducer } from './PlatformSettings'
import { potentialCollaboratorReducer } from './PotentialCollaborators'
import { preAuditQualifierReducer } from './FetchPreAuditQualifier'
import { preAuditQuestionReducer } from './FetchPreAuditQuestions'
import { provinceReducer } from './Province'
import { questionnaireResultReducer } from './SheScoreCard'
import { raceReducer } from './Race'
import { rankingsReducer } from './Ranking'
import { rankingStatusReducer } from './RankingStatus'
import { referenceReviewReducer } from './ReferenceReview'
import { reInviteReducer } from './Reinvite'
import { reportUrlReducer } from './ReportUrl'
import { registrationRequestReducer } from './registrationRequest'
import { scmCompanyReducer } from './ScmCompany'
import { scmStatisticsReducer } from './ScmStatistics'
import { sheComplianceReducer } from './SheCompliance'
import { sheQuestionnaireReducer } from './SheQuestionnaire'
import { smeCompanyGrowthPlanReducer } from './SmeCompanyGrowthPlan'
import { smeCompanyReducer } from './SmeCompany'
import { smeCompletenessReducer } from './SmeCompleteness'
import { smmeCSDReportEmailReducer } from './SmmeCSDReportEmail'
import { smeDevPlanReducer } from './SmeDevPlan'
import { subscriptionReducer } from './Subscription'
import { subSectorReducer } from './SubSector'
import { titleReducer } from './Title'
import { townReducer } from './Town'
import { userReducer } from './User'
import { missingGradingDocumentsReducer } from './MissingGradingDocuments'
import { opportunityCompanyDocumentReducer } from './OpportunityCompanyDocument'

export function _configureStore(history, initialState) {
	const reducers = {
		router: connectRouter(history),
		location: window.location,
		layout: Layout.reducer,
		sideMenu: SideMenu.reducer,
		faq: faqReducer,
		userManagement: UserManagement.reducer,
		searchStore: SearchStore.reducer,

		// REDUCERS
		accreditationReview: accreditationReviewReducer,
		addressType: addressTypeReducer,
		adminStatistics: adminStatisticsReducer,
		adminUnlockQuestionnaire: adminUnlockQuestionnaireReducer,
		auth: authReducer,
		banks: bankReducer,
		beeStatuses: beeStatusReducer,
		registrationStatuses: registrationStatusReducer,
		city: cityReducer,
		clientReferences: clientReferenceReducer,
		company: companyReducer,
		companyAddress: companyAddressReducer,
		companyContact: companyContactReducer,
		companyDirectors: companyDirectorReducer,
		companyDocumentExpired: companyDocumentExpiredReducer,
		companyDocuments: companyDocumentReducer,
		companyOwners: companyOwnerReducer,
		companyOwnerships: companyOwnershipReducer,
		companyRankingReducer: companyRankingReducer,
		companyType: companyTypeReducer,
		complianceReferences: complianceReferenceReducer,
		documentRejectionReason: documentRejectionReasonReducer,
		documentStatus: documentStatusReducer,
		documentTypes: documentTypeReducer,
		economicSector: economicSectorReducer,
		educationLevels: educationLevelReducer,
		enterpriseSizes: enterpriseSizeReducer,
		esdStatistics: esdStatisticsReducer,
		fundingRecommendationForm: fundingRecommendationReducer,
		gender: genderReducer,
		growthPlanPeriods: growthPlanPeriodReducer,
		industries: industryReducer_,
		industry: industryReducer,
		industryGroup: industryGroupReducer,
		industrySector: industrySectorReducer,
		industrySectors: industrySectorReducer_,
		industrySubSectors: industrySubSectorReducer,
		invite: inviteReducer,
		itemToBeFunded: itemToBeFundedReducer,
		liabilities: addLiabilitiesReducer,
		loanApplicationForm: loanApplicationReducer,
		localMunicipality: localMunicipalityReducer,
		loginReusePrevention: LoginReusePreventionReducer,
		municipality: municipalityReducer,
		nationalities: nationalityReducer,
		notificationMessages: notificationMessageReducer,
		opportunities: opportunityReducer,
		opportunitiesInterests: opportunitiesInterestsReducer,
		opportunityCollaborators: opportunityCollaboratorsReducer,
		permissions: PermissionReducer,
		platformFeatures: platformFeaturesReducer,
		platformSettings: platformSettingsReducer,
		potentialCollaborators: potentialCollaboratorReducer,
		preAuditQualifier: preAuditQualifierReducer,
		preAuditQuestion: preAuditQuestionReducer,
		promisedDocuments: promisedDocumentsReducer,
		province: provinceReducer,
		questionnaireResult: questionnaireResultReducer,
		races: raceReducer,
		rankings: rankingsReducer,
		rankingStatus: rankingStatusReducer,
		referenceReview: referenceReviewReducer,
		reInvite: reInviteReducer,
		reportUrl: reportUrlReducer,
		scmCompany: scmCompanyReducer,
		scmStatistics: scmStatisticsReducer,
		sheComplianceStatus: sheComplianceReducer,
		sheQuestionnaire: sheQuestionnaireReducer,
		sme: smeReducer,
		smeCompany: smeCompanyReducer,
		smeCompanyGrowthPlans: smeCompanyGrowthPlanReducer,
		smeCompleteness: smeCompletenessReducer,
		smmeCSDReportEmail: smmeCSDReportEmailReducer,
		smeDevPlans: smeDevPlanReducer,
		subscriptions: subscriptionReducer,
		subSector: subSectorReducer,
		title: titleReducer,
		town: townReducer,
		users: userReducer,
		missingGradingDocuments: missingGradingDocumentsReducer,
		registrationRequests: registrationRequestReducer,
		opportunityCompanyDocuments: opportunityCompanyDocumentReducer
	}


	const dbghelper =  ({ dispatch, getState }) => next => action => {
		// window.state = getState()
		return next(action)
	}

	const middleware = [thunk, routerMiddleware(history), dbghelper]

	// In development, use the browser's Redux dev tools extension if installed
	const enhancers = []
	const isDevelopment = process.env.NODE_ENV === 'development'
	if (isDevelopment && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
		enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true, traceLimit: 25 }))
	}
	const rootReducer = combineReducers({
		...reducers,
		form: formReducer,
	})

	return createStore(rootReducer, initialState, compose(applyMiddleware(...middleware), ...enhancers))
}

// create default store and return

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0] ? document.getElementsByTagName('base')[0].getAttribute('href') : '/'
export const browserHistory = createBrowserHistory({ basename: baseUrl })

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState
const store = _configureStore(browserHistory, initialState)

export function getStore() {
	return store
}
// TODO: fix the global variable, couldn't find any better solution
//       used in axios.js ...
window.store = store

export default store
